export const EMPTY_TEXT = '__NULL__';
